import React from 'react';
import { FadeIn } from './FadeIn';
export function PremiumJustification() {
  const comparisons = [{
    sit: 'Tu imagen profesional',
    sin: 'Tu nombre y un Instagram informal',
    con: 'Identidad visual coherente y profesional'
  }, {
    sit: 'Repertorio popular',
    sin: 'Buscás partituras en internet',
    con: '30 piezas de películas adaptadas a 4 niveles'
  }, {
    sit: 'Tu manejo emocional del oficio',
    sin: 'Resolvés solo los problemas duros',
    con: 'Manual completo con casos reales y soluciones'
  }, {
    sit: 'Tus honorarios',
    sin: 'Los del mercado o menos',
    con: 'Sistema para subir precios sin perder alumnos'
  }, {
    sit: 'Tus redes sociales',
    sin: 'Irregulares, sin estrategia',
    con: '7 categorías + sistema realista de contenidos'
  }, {
    sit: 'Tu vocabulario pedagógico',
    sin: 'El que recordás del conservatorio',
    con: '200 términos con 3 explicaciones por edad'
  }, {
    sit: 'Tu identidad profesional',
    sin: 'Improvisada',
    con: 'Sistema completo de marca personal'
  }];
  const bonusNames = ['🎬 Partituras de Películas', '📖 Manual de Supervivencia', '📚 Diccionario del Piano', '✨ Marca Personal', '💰 Cómo Cobrar lo que Vales', '📱 Instagram para Profes'];
  return <section className="bg-cream py-24" data-id="element-141">
      <div className="container mx-auto px-6" data-id="element-142">
        <FadeIn className="text-center max-w-3xl mx-auto mb-16" data-id="element-143">
          <h2 className="font-display font-bold text-3xl md:text-5xl text-navy-900 mb-4" data-id="element-144">
            🎹 ¿Qué agrega el plan PREMIUM?
          </h2>
          <p className="font-accent italic text-xl md:text-2xl text-primaryBlue mb-6" data-id="element-145">
            Tu sistema completo de profesionalización.
          </p>
          <p className="text-gray-700 text-lg leading-relaxed" data-id="element-146">
            Porque enseñar piano que ya hacés bien debería tener el respaldo
            profesional que merece. El plan Premium hace eso.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} className="max-w-5xl mx-auto mb-16 overflow-x-auto" data-id="element-147">
          <table className="w-full text-left border-collapse bg-white rounded-xl overflow-hidden shadow-sm border border-gray-200 min-w-[700px]" data-id="element-148">
            <thead data-id="element-149">
              <tr className="bg-navy-900 text-white" data-id="element-150">
                <th className="p-4 md:p-6 font-bold w-1/3 border-b border-navy-800" data-id="element-151">
                  Situación
                </th>
                <th className="p-4 md:p-6 font-bold w-1/3 border-b border-navy-800 text-gray-400" data-id="element-152">
                  Sin Premium
                </th>
                <th className="p-4 md:p-6 font-bold w-1/3 border-b border-navy-800 text-gold bg-navy-800" data-id="element-153">
                  Con Premium
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-154">
              {comparisons.map((row, i) => <tr key={i} className="hover:bg-gray-50 transition-colors" data-id="element-155">
                  <td className="p-4 md:p-6 font-medium text-navy-900" data-id="element-156">
                    {row.sit}
                  </td>
                  <td className="p-4 md:p-6 text-gray-500" data-id="element-157">{row.sin}</td>
                  <td className="p-4 md:p-6 text-navy-800 font-medium bg-gold/5" data-id="element-158">
                    {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </FadeIn>

        <FadeIn delay={0.4} className="max-w-4xl mx-auto bg-navy-900 rounded-2xl p-8 md:p-10 border border-gold/30 shadow-xl relative overflow-hidden" data-id="element-159">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-[80px] pointer-events-none" data-id="element-160"></div>

          <h3 className="text-gold font-bold text-xl md:text-2xl mb-8 text-center" data-id="element-161">
            ✅ EL PLAN PREMIUM INCLUYE 6 BONOS EXCLUSIVOS:
          </h3>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-162">
            {bonusNames.map((name, i) => <div key={i} className="bg-navy-800 border border-gold/20 rounded-lg p-4 text-center hover:border-gold/50 transition-colors" data-id="element-163">
                <span className="text-white font-medium text-sm md:text-base" data-id="element-164">
                  {name}
                </span>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}